<countdown [config]="{ leftTime: 59, format: 'mm:ss' }"></countdown>